var user = window.user;
var message = window.message;
var actions = window.actions;
var actions, message, user;
if (window.confirmAccountEmail) {
  user = Aedu.User.current;
  if (!user.banned) {
    message = "Please confirm your account. We've sent a confirmation link to " + window.confirmAccountEmail;
    actions = {
      'Resend': function () {
        return document.location = '/confirm/send_new_email';
      },
      'Change Email': function () {
        return document.location = '/confirm/sent#email';
      }
    };
  } else if (!user.requested_unflag) {
    message = "Your account was flagged as suspicious by an automated system. If this was an error, please accept our apologies.";
    actions = {
      'Request Unflagging': function () {
        return document.location = '/user_unflag_requests/new';
      }
    };
  } else {
    message = "Your account was flagged as suspicious, and your reconsideration request is awaiting manual review. We're sorry for any inconvenience.";
  }
  $(document).ready(function () {
    return new ConfirmationBanner.BelowNavView({
      mode: 'warning',
      message: message,
      actions: actions
    }).render();
  });
}
window.actions = actions;
window.message = message;
window.user = user;